/**
 * Cuál de las fotos de un animal es la PORTADA.
 *
 * La que el productor marcó (`es_portada`), y si no marcó ninguna, la primera
 * —que es el comportamiento que hubo siempre—. **Esa caída no es una comodidad:
 * hay 205 imágenes cargadas y ninguna marcada, así que sin ella todos los
 * animales del sistema se quedarían de golpe sin miniatura.**
 *
 * ES EL MISMO CRITERIO QUE APLICA EL BACKEND en `_portada_de()`
 * (`micrositio_routes.py`), y por eso vive acá y no escrito adentro de una
 * pantalla: las miniaturas del panel tienen que mostrar la MISMA foto que el
 * micrositio público usa de portada. Dos criterios distintos para lo mismo
 * significan que el productor marca una portada, ve otra en el panel, y no
 * entiende cuál va a salir publicada.
 *
 * `imagenes` tiene que venir ordenada como la manda el backend (por id).
 */
export const portadaDe = (imagenes) => {
  const lista = imagenes || [];
  if (!lista.length) return null;
  return lista.find((i) => i.es_portada) || lista[0];
};
